module.exports = __webpack_public_path__ + "static/sorghum-c43a582f42716e8129249febd7ed6188.jpg";